import { Col, Row } from 'reactstrap';
import React, { useEffect, useRef, useState } from 'react';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import ViewTable from 'app/shared/view-table/view-table';
import { CaseActModel } from 'app/edozvola/cases/cases.model';
import { searchPublishedCaseActsQuery } from 'app/edozvola/cases/case-acts/service/case-acts.queries';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Input } from 'edozvola-frontend-lib/dist/ui';
import { getCaseActFile } from 'app/edozvola/cases/service/cases.service';
import { showToast } from 'app/shared/util/toast.util';
import { convertDateFromServer } from 'app/shared/util/date-utils';
import { openFileInNewWindow } from 'app/shared/util/navigation-util';

const NoticeBoard = () => {
  const [searchParam, setSearchParam] = useState<string>('');
  const inputRef = useRef<HTMLInputElement>(null);
  const lastChange = useRef<number>();

  const downloadFile = (caseAct: CaseActModel) => {
    getCaseActFile(caseAct.idCaseAct)
      .then(data => {
        if (data) {
          openFileInNewWindow(data.url);
        }
      })
      .catch(err => showToast(err, 'Dogodila se greška prilikom preuzimanja dokumenta.'));
  };

  const handleSearchParamChange = (newValue: string) => {
    if (inputRef.current) {
      inputRef.current.value = newValue;
    }
    if (lastChange.current) {
      clearTimeout(lastChange.current);
    }
    lastChange.current = setTimeout(() => {
      lastChange.current = null;
      setSearchParam(newValue.trimEnd());
    }, 500);
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = searchParam;
    }
  }, []);

  const renderNoticesTableRow = (value: CaseActModel, caseActIndex: number) => {
    return (
      <tr key={caseActIndex}>
        <td>{convertDateFromServer(value.publishStartDate)}</td>
        <td>{convertDateFromServer(value.publishEndDate)}</td>
        <td>{value.name}</td>
        <td>{value.classification}</td>
        <td>{value.fileNumber}</td>
        <td>{convertDateFromServer(value.createdDate)}</td>
        <td style={{ whiteSpace: 'pre-wrap' }}>
                 {value.applicantName?.replace(/;/g, ';\n')}
        </td>
        <td style={{ whiteSpace: 'pre-wrap' }}>
          {value.locations?.replace(/;/g, ';\n')}
        </td>
        <td>
          <FontAwesomeIcon icon={'file'} className={'icon-table'} onClick={() => downloadFile(value)} />
        </td>
      </tr>
    );
  };

  return <div className={'container-fluid view-container'}>
    <Row className="mb-4">
      <Col md={12}>
        <div className={'mb-3 form-header'}>Oglasna ploča</div>
      </Col>
    </Row>
    <Row className="mb-4">
      <Col md={4}>
        <Input
          addonPrepend={<FontAwesomeIcon icon="search" />}
          placeholder="Pretražite"
          innerRef={inputRef}
          onChange={e => handleSearchParamChange(e.target.value)}
        />
      </Col>
    </Row>
    <ViewTable
      initialPaginationColumn="createdDate"
      initialSortDirection="desc"
      renderTableRow={renderNoticesTableRow}
      noDataMessage={searchParam ? 'Nema objavljenih akata koji odgovaraju unesenom pojmu.'
                                            : 'Nema objavljenih akata.'}
      fetchDataQuery={searchPublishedCaseActsQuery}
      fetchDataProps={searchParam}
    >
      <ViewTableHeaderColumn renderSort sortKey={'publishStartDate'} columnLabels={['Početak oglašavanja']} />
      <ViewTableHeaderColumn renderSort sortKey={'publishEndDate'} columnLabels={['Završetak oglašavanja']} />
      <ViewTableHeaderColumn renderSort sortKey={'name'} columnLabels={['Naziv akta']} />
      <ViewTableHeaderColumn renderSort sortKey={'classification'} columnLabels={['Klasifikacijska oznaka']} />
      <ViewTableHeaderColumn renderSort sortKey={'fileNumber'} columnLabels={['Urudžbeni broj']} />
      <ViewTableHeaderColumn renderSort sortKey={'createdDate'} columnLabels={['Datum nastanka']} />
      <ViewTableHeaderColumn renderSort sortKey={'applicantFirstName'} columnLabels={['Podnositelj']} />
      <ViewTableHeaderColumn renderSort sortKey={'locations'} columnLabels={['Lokacija - naselje']} />
      <ViewTableHeaderColumn renderSort={false} columnLabels={['Akt']} />
    </ViewTable>
  </div>
}

export default NoticeBoard;
